import Login from './modules/Login'; // 登录相关
import Operation from './modules/Operation'; // 运营管理相关
import System from './modules/System'; // 系统设置相关
import shouye from './module/index'; // 前台
import My from './module/my'; // 前台我的
import Product from './module/product/product'; // 前台样衣发布
import ProductManage from './module/productManage/productManage'; // 前台样衣管理
import Colorcard from './module/colorcard/colorcard'; // 前台色卡管理模块
import BasicData from './module/basicData/basicData'; // 前台基础资料模块
import Home from './module/home/home'; // 前台供应商和关注模块
import Promotion from './module/promotion/promotion'; // 前台关联推广模块

export default {
  Login,
  Operation,
  System,
  shouye,
  My,
  Product,
  ProductManage,
  Colorcard,
  BasicData,
  Home,
  Promotion
}
